export default __webpack_public_path__ + "57ac4df72d85a86f76e15c3b4e3f69e4.svg";